import React from 'react';
import { Element } from 'react-scroll';
import Slider from 'react-slick';
import 'react-photoswipe/lib/photoswipe.css';
import { CustomPhotoSwipe, CustomSlider, Submenu } from '../components';

export default (props) => (

  <div className="Content EVisual-Content">

  	<span className="Mob-Title"> <h3 className="red-txt"> Expressão Visual </h3> </span>

  	<h2> Teoria dos arcos, padrões <br/> e linhas criativas </h2>

    <Submenu
      links={[
        { to: "para-que-serve?", title: "Para que <br/> serve?", offset: -200 },
        { to: "elementos-diferenciados", title: "Elementos <br/> diferenciadores", offset: -200 },
        { to: "teoria-dos-arcos", title: "Teoria dos arcos", offset: -200 },
        { to: "fotografia", title: "Fotografia", offset: -200 },
        { to: "aplicação-de-marca-e-slogan", title: "Aplicação de <br/> marca e slogan", offset: -200 },
        { to: "cores", title: "Cores", offset: -200 },
        { to: "textura", title: "Textura", offset: -200 },
        { to: "banco-de-icones", title: "Banco de ícones", offset: -150 },
        { to: "tipografia", title: "Tipografia", offset: -150 }
      ]} />

  <Element name="para-que-serve?" className="Block Black-Block">

    <div className="Text-Wrapper Content-Ajust white-txt">
      <h1> Para que serve ? </h1>

      <p className="p-ajust"> A expressão visual desenvolvida
      para a Brasal tem como objetivo definir diretrizes gráficas que
      tragam unidade visual aos esforços de comunicação da marca. Para isso,
      temos uma série de princípios que guiam a construção de materiais de
      comunicação. </p>

      <p className="p-ajust"> As diretrizes aqui apresentadas não devem ser
      vistas como mecanismo de cerceamento criativo, e sim como um grande aliado
      para resultado mais sólidos no que diz respeito à valorização da marca. Nas
      próximas páginas, você vai conhecer essas diretrizes visuais e seus
      desdobramentos. </p>

    </div>
  </Element>

  <Element name="elementos-diferenciados" className="Block">

    <h1 className="red-txt Mob-Title"> Elementos diferenciadores </h1>

    <div className="Text-Wrapper Text-Left second">

      <h1 className="red-txt Hide-Mobile"> Elementos diferenciadores </h1>

      <p> A expressão visual se apoia em elementos que ajudam a representar
      graficamente nosso discurso. Esses elementos são que chamamos de elementos
      diferenciadores, que foram escolhidos para representar a <strong> Teoria do Paradoxo </strong>
      e a <strong> Teoria dos Arcos. </strong> </p>

      <h4> Arcos Brasal </h4>

      <p> Servem como plataforma para apresentar nosso discurso, são a base visual de todos os layouts.
      Os arcos são posicionados de acordo com o público da peça:
      <br/> <strong> Público externo: </strong> Arco superior
      <br/> <strong> Público interno: </strong> Arco inferior </p>

      <h4> Pessoas </h4>

      <p> O atributo central da estratégia Brasal e elemento máximo da conexão entre posicionamento,
      essência e atributos. Representam nossos clientes ou colaboradores, dependendo do objetivo da peça. </p>

      <h4> Elemento especial </h4>

      <p> São elementos criados de acordo com a necessidade da mensagem. Eles fazem parte da mensagem de forma
      relevante e podem ser criados de acordo com a necessidade de comunicação. Seu uso é facultativo.
      Ex: Letras de vidro para destacar atributos na campanha institucional Brasal. </p>

    </div>

    <div className="Img-Wrapper Center first Fill">
      <img src={require("../img/EVisual/elementos.png")}/>
    </div>
  </Element>

  <Element name="teoria-dos-arcos">
    <Element className="Block Player-Block">
      <div className="Text-Wrapper">
        <h1 className="red-txt p-ajust"> Teoria dos arcos </h1>

        <p className="p-ajust"> Expressão visual = identidade + verbal + marca </p>
        <p className="p-ajust"> A identidade visual da marca é dinâmica no seu diálogo com o cada público e cada contexto, mas tem
        sempre o mesmo ponto de partida: os arcos da marca. </p>
      </div>

      <div className="Player">
        <CustomSlider>
          <div><img src={require("../img/EVisual/Players/teoria-dos-arcos@2x.jpg")} alt="" /></div>
          <div><img src={require("../img/EVisual/Players/teoria-dos-arcos@2x2.jpg")} alt="" /></div>
          <div><img src={require("../img/EVisual/Players/teoria-dos-arcos@2x3.jpg")} alt="" /></div>
        </CustomSlider>
      </div>
    </Element>

    <div className="Block Player-Block">
      <div className="Text-Wrapper Center">
        <h1 className="red-txt"> Exemplos <br/> de peças </h1>
      </div>

      <div className="Player">
        <CustomSlider>
          <div><img src={require("../img/EVisual/Players/pecas.jpg")} alt="" /></div>
          <div><img src={require("../img/EVisual/Players/pecas2.jpg")} alt="" /></div>
          <div><img src={require("../img/EVisual/Players/pecas3.jpg")} alt="" /></div>
        </CustomSlider>
      </div>
    </div>
  </Element>

  <Element name="fotografia">
    <Element name="fotografia" className="Block">

      <h1 className="red-txt Mob-Title"> Fotografia </h1>

      <div className="Text-Wrapper Text-Left second">

        <h1 className="red-txt Hide-Mobile"> Fotografia </h1>

        <p> Nosso banco de imagens foi construído de forma a ter consistência visual e criar identidade para
        a marca Brasal. Ele é composto de imagens próprias e imagens licenciadas. </p>

      <h4> Imagens próprias vs. imagens licenciadas </h4>

        <p> O banco de imagens da Brasal é composto por imagens produzidas com exclusividade para a empresa e
        imagens licenciadas de banco de imagens pagas. As produzidas têm a vantagem de terem sido feitas sob demanda,
        tem uso exclusivo da Brasal e trazem mais identidade para layouts. Já as imagens licenciadas tem papel de
        complementar nosso banco e permitir maior heterogeneidade das peças. </p>

        <h4> Pessoas </h4>

        <p> O atributo central da estratégia Brasal e elemento máximo da conexão entre posicionamento,
        essência e atributos. Representam nossos clientes ou colaboradores, dependendo do objetivo da peça. </p>

        <h4> Ampliam as possibilidades </h4>

        <p> O banco de imagens próprias tem o papel de dar personalidade à nossa comunicação, já as imagens
        licenciadas tem o papel fundamental na redução de custos de produção e na possibilidade de aumentar a
        quantidade de imagens usadas nas campanhas. </p>

      </div>

      <div className="Img-Wrapper Center first">
        <img src={require("../img/EVisual/fotografia.png")}/>
      </div>
    </Element>

    <div className="Block Player-Block">
      <div className="Text-Wrapper Center">
        <h1 className="red-txt"> Imagens <br/> próprias </h1>
      </div>

      <div className="Block Hide-Desktop">
        <h4> Holding </h4>

        <div className="Img-Wrapper">
          <CustomSlider>
            <div><img src={require("../img/EVisual/bloco1img1.png")} alt="" /></div>
            <div><img src={require("../img/EVisual/bloco1img2.png")} alt="" /></div>
            <div><img src={require("../img/EVisual/bloco1img3.png")} alt="" /></div>
            <div><img src={require("../img/EVisual/bloco1img4.png")} alt="" /></div>
            <div><img src={require("../img/EVisual/bloco1img5.png")} alt="" /></div>
            <div><img src={require("../img/EVisual/bloco1img6.png")} alt="" /></div>
          </CustomSlider>
        </div>
      </div>

      <div className="Block Hide-Mobile">
        <div className="Holding">
          <h4> Holding </h4>

          <img src={require("../img/EVisual/bloco1img1.png")}/>

          <img src={require("../img/EVisual/bloco1img2.png")}/>

          <img src={require("../img/EVisual/bloco1img3.png")}/>

          <img src={require("../img/EVisual/bloco1img4.png")}/>

          <img src={require("../img/EVisual/bloco1img5.png")}/>

          <img src={require("../img/EVisual/bloco1img6.png")}/>

        </div>
      </div>

      <div className="Block Hide-Desktop">
        <h4> Refrigerantes </h4>

        <div className="Img-Wrapper">
          <CustomSlider>
            <div><img src={require("../img/EVisual/bloco2img1.jpg")} alt="" /></div>
            <div><img src={require("../img/EVisual/bloco2img2.jpg")} alt="" /></div>
            <div><img src={require("../img/EVisual/bloco2img3.jpg")} alt="" /></div>
            <div><img src={require("../img/EVisual/bloco2img4.jpg")} alt="" /></div>
            <div><img src={require("../img/EVisual/bloco2img5.jpg")} alt="" /></div>
            <div><img src={require("../img/EVisual/bloco2img6.jpg")} alt="" /></div>
          </CustomSlider>
        </div>
      </div>

      <div className="Block Hide-Mobile">
        <div className="Holding">
          <h4> Refrigerantes </h4>

          <img src={require("../img/EVisual/bloco2img1.jpg")}/>

          <img src={require("../img/EVisual/bloco2img2.jpg")}/>

          <img src={require("../img/EVisual/bloco2img3.jpg")}/>

          <img src={require("../img/EVisual/bloco2img4.jpg")}/>

          <img src={require("../img/EVisual/bloco2img5.jpg")}/>

          <img src={require("../img/EVisual/bloco2img6.jpg")}/>

        </div>
      </div>

      <div className="Block Hide-Desktop">
        <h4> Incorporações </h4>

        <div className="Img-Wrapper">
          <CustomSlider>
            <div><img src={require("../img/EVisual/bloco3img1.jpg")} alt="" /></div>
            <div><img src={require("../img/EVisual/bloco3img2.jpg")} alt="" /></div>
            <div><img src={require("../img/EVisual/bloco3img3.jpg")} alt="" /></div>
            <div><img src={require("../img/EVisual/bloco3img4.jpg")} alt="" /></div>
            <div><img src={require("../img/EVisual/bloco3img5.jpg")} alt="" /></div>
            <div><img src={require("../img/EVisual/bloco3img6.jpg")} alt="" /></div>
          </CustomSlider>
        </div>
      </div>

      <div className="Block Hide-Mobile">
        <div className="Holding">
          <h4> Incorporações </h4>

          <img src={require("../img/EVisual/bloco3img1.jpg")}/>

          <img src={require("../img/EVisual/bloco3img2.jpg")}/>

          <img src={require("../img/EVisual/bloco3img3.jpg")}/>

          <img src={require("../img/EVisual/bloco3img4.jpg")}/>

          <img src={require("../img/EVisual/bloco3img5.jpg")}/>

          <img src={require("../img/EVisual/bloco3img6.jpg")}/>

        </div>
      </div>

      <div className="Block Hide-Desktop">
        <h4> Veículos </h4>

        <div className="Img-Wrapper">
          <CustomSlider>
            <div><img src={require("../img/EVisual/bloco4img1.jpg")} alt="" /></div>
            <div><img src={require("../img/EVisual/bloco4img2.jpg")} alt="" /></div>
            <div><img src={require("../img/EVisual/bloco4img3.jpg")} alt="" /></div>
            <div><img src={require("../img/EVisual/bloco4img4.jpg")} alt="" /></div>
            <div><img src={require("../img/EVisual/bloco4img5.jpg")} alt="" /></div>
            <div><img src={require("../img/EVisual/bloco4img6.jpg")} alt="" /></div>
          </CustomSlider>
        </div>
      </div>

      <div className="Block Hide-Mobile">
        <div className="Holding">
          <h4> Veículos </h4>

          <img src={require("../img/EVisual/bloco4img1.jpg")}/>

          <img src={require("../img/EVisual/bloco4img2.jpg")}/>

          <img src={require("../img/EVisual/bloco4img3.jpg")}/>

          <img src={require("../img/EVisual/bloco4img4.jpg")}/>

          <img src={require("../img/EVisual/bloco4img5.jpg")}/>

          <img src={require("../img/EVisual/bloco4img6.jpg")}/>

        </div>
      </div>

      <div className="Block Hide-Desktop">
        <h4> Combustíveis </h4>

        <div className="Img-Wrapper">
          <CustomSlider>
            <div><img src={require("../img/EVisual/bloco5img1.jpg")} alt="" /></div>
            <div><img src={require("../img/EVisual/bloco5img2.jpg")} alt="" /></div>
            <div><img src={require("../img/EVisual/bloco5img3.jpg")} alt="" /></div>
            <div><img src={require("../img/EVisual/bloco5img4.jpg")} alt="" /></div>
            <div><img src={require("../img/EVisual/bloco5img5.jpg")} alt="" /></div>
            <div><img src={require("../img/EVisual/bloco5img6.jpg")} alt="" /></div>
          </CustomSlider>
        </div>
      </div>

      <div className="Block Hide-Mobile">
        <div className="Holding">
          <h4> Combustíveis </h4>

          <img src={require("../img/EVisual/bloco5img1.jpg")}/>

          <img src={require("../img/EVisual/bloco5img2.jpg")}/>

          <img src={require("../img/EVisual/bloco5img3.jpg")}/>

          <img src={require("../img/EVisual/bloco5img4.jpg")}/>

          <img src={require("../img/EVisual/bloco5img5.jpg")}/>

          <img src={require("../img/EVisual/bloco5img6.jpg")}/>

        </div>
      </div>

      <div className="Block Hide-Desktop">
        <h4> Sia Park </h4>

        <div className="Img-Wrapper">
          <CustomSlider>
            <div><img src={require("../img/EVisual/bloco7img1.jpg")} alt="" /></div>
            <div><img src={require("../img/EVisual/bloco7img2.jpg")} alt="" /></div>
            <div><img src={require("../img/EVisual/bloco7img3.jpg")} alt="" /></div>
            <div><img src={require("../img/EVisual/bloco7img4.jpg")} alt="" /></div>
            <div><img src={require("../img/EVisual/bloco7img5.jpg")} alt="" /></div>
            <div><img src={require("../img/EVisual/bloco7img6.jpg")} alt="" /></div>
          </CustomSlider>
        </div>
      </div>

      <div className="Block Hide-Mobile">
        <div className="Holding">
          <h4> Sia Park  </h4>

          <img src={require("../img/EVisual/bloco7img1.jpg")}/>

          <img src={require("../img/EVisual/bloco7img2.jpg")}/>

          <img src={require("../img/EVisual/bloco7img3.jpg")}/>

          <img src={require("../img/EVisual/bloco7img4.jpg")}/>

          <img src={require("../img/EVisual/bloco7img5.jpg")}/>

          <img src={require("../img/EVisual/bloco7img6.jpg")}/>

        </div>
      </div>

    </div>

    <div className="Text-Wrapper Center">
      <h1 className="red-txt"> Imagens <br/> licenciadas </h1>
    </div>

    <div className="Block">

      <div className="Text-Wrapper Text-Left Content-Ajust second">

        <h4> Estrutura <br/> imagens <br/> licenciadas </h4>

        <p> Como decidir quais imagens licenciar. </p>
        <p> Ao escolher uma nova imagem a ser licenciada observe as seguintes perguntas. </p>

          <ul>
            <li> <p> A personagem na foto tem biotipo brasileiro ? </p> </li>
            <li> <p> A atitude da personagem é positiva? </p> </li>
            <li> <p> A pose está natural, sem gestos forçados como “joia” e “ok” ? </p> </li>
            <li> <p> As cores predominantes correspondem às nossas ? </p> </li>
            <li> <p> A ambientação poderia estar em nosso país ? </p> </li>
          </ul>

        <p> Caso a resposta para todas elas seja positiva, a foto segue a linguagem do banco de imagens. </p>

      </div>

      <CustomPhotoSwipe items={[{
          src: require('../img/EVisual/licenciadas.jpg'),
          w: 1200,
          h: 1200,
          title: 'Imagens Licenciadas'
        }]}>
        <div className="Img-Wrapper first Fill">
          <img src={require("../img/EVisual/licenciadas.jpg")}/>
          <div className="lupa"> <img src={require("../img/lupa.svg")}/> </div>
        </div>
      </CustomPhotoSwipe>

    </div>

    <div className="Block Hide-Desktop">
      <h4> Holding </h4>

      <div className="Img-Wrapper">
        <CustomSlider>
          <div><img src={require("../img/EVisual/blocoL1img1.jpg")} alt="" /></div>
          <div><img src={require("../img/EVisual/blocoL1img2.jpg")} alt="" /></div>
          <div><img src={require("../img/EVisual/blocoL1img3.jpg")} alt="" /></div>
          <div><img src={require("../img/EVisual/blocoL1img4.jpg")} alt="" /></div>
          <div><img src={require("../img/EVisual/blocoL1img5.jpg")} alt="" /></div>
          <div><img src={require("../img/EVisual/blocoL1img6.jpg")} alt="" /></div>
        </CustomSlider>
      </div>
    </div>

    <div className="Block Hide-Mobile">
      <div className="Holding">
        <h4> Holding </h4>

        <img src={require("../img/EVisual/blocoL1img1.jpg")}/>

        <img src={require("../img/EVisual/blocoL1img2.jpg")}/>

        <img src={require("../img/EVisual/blocoL1img3.jpg")}/>

        <img src={require("../img/EVisual/blocoL1img4.jpg")}/>

        <img src={require("../img/EVisual/blocoL1img5.jpg")}/>

        <img src={require("../img/EVisual/blocoL1img6.jpg")}/>

      </div>
    </div>

    <div className="Block Hide-Desktop">
      <h4> Incorporações </h4>

      <div className="Img-Wrapper">
        <CustomSlider>
          <div><img src={require("../img/EVisual/blocoL3img1.jpg")} alt="" /></div>
        </CustomSlider>
      </div>
    </div>

    <div className="Block Hide-Mobile">
      <div className="Holding">
        <h4> Incorporações </h4>

        <img src={require("../img/EVisual/blocoL3img1.jpg")}/>

      </div>
    </div>

    <div className="Block Hide-Desktop">
      <h4> Veículos </h4>

      <div className="Img-Wrapper">
        <CustomSlider>
          <div><img src={require("../img/EVisual/blocoL4img1.jpg")} alt="" /></div>
          <div><img src={require("../img/EVisual/blocoL4img2.jpg")} alt="" /></div>
          <div><img src={require("../img/EVisual/blocoL4img3.jpg")} alt="" /></div>
        </CustomSlider>
      </div>
    </div>

    <div className="Block Hide-Mobile">
      <div className="Holding">
        <h4> Veículos </h4>

        <img src={require("../img/EVisual/blocoL4img1.jpg")}/>

        <img src={require("../img/EVisual/blocoL4img2.jpg")}/>

        <img src={require("../img/EVisual/blocoL4img3.jpg")}/>

      </div>
    </div>

    <div className="Block Hide-Desktop">
      <h4> Combustíveis </h4>

      <div className="Img-Wrapper">
        <CustomSlider>
          <div><img src={require("../img/EVisual/blocoL5img1.jpg")} alt="" /></div>
        </CustomSlider>
      </div>
    </div>

    <div className="Block Hide-Mobile">
      <div className="Holding">
        <h4> Combustíveis </h4>

        <img src={require("../img/EVisual/blocoL5img1.jpg")}/>

      </div>
    </div>
  </Element>

  <Element name="aplicação-de-marca-e-slogan" className="Block Player-Block">
    <div className="Text-Wrapper">
      <h1 className="red-txt"> Aplicação de marca e slogan </h1>

      <p> A posição prioritária da aplicação da marca é no canto superior direito para materiais para o público
      externo e inferior direito para as peças para público interno. </p>
    </div>

    <div className="Player">
      <CustomSlider>
        <div><img src={require("../img/EVisual/Players/slogan.jpg")} alt="" /></div>
        <div><img src={require("../img/EVisual/Players/slogan2.jpg")} alt="" /></div>
      </CustomSlider>
    </div>
  </Element>

  <Element name="cores">
    <Element className="Block Player-Block">
      <div className="Text-Wrapper">
        <h1 className="red-txt"> Cores </h1>

        <p> A paleta de cores guia toda a criação de material visual da Brasal. Ela deve ser consultada antes e
        durante produções fotográficas, videográficas, impressas e digitais. </p>
        <p> Conheça essa tabela de cores. </p>
      </div>

      <div className="Holding Full">
        <h4> Holding </h4>

        <div className="Color">
          <div className="Color-darkblue"></div>
          <div> #273c4d </div>
          <div> c:80 m:60 y:40 k:50 </div>
        </div>

        <div className="Color">
          <div className="Color-red"></div>
          <div> #ec1f24 </div>
          <div> c:0 m:100 y:100 k:0 </div>
        </div>

        <div className="Color">
          <div className="Color-grey"></div>
          <div> #bdbcc1 </div>
          <div> c:0 m:0 y:0 k:30 </div>
        </div>

      </div>
    </Element>

    <div className="Block Player-Block">
      <div className="Text-Wrapper">
        <h1 className="red-txt"> Cores segmentos </h1>

        <p> São cores definidas para diferencias as áreas de atuação da Brasal.
        Cada segmento tem sua cor específica que deve fazer parte da comunicação. </p>
      </div>

      <div className="Holding">
        <h4> Veículos </h4>

        <div className="Color">
          <div className="Color-darkblue"></div>
          <div> #273c4d </div>
          <div> c:80 m:60 y:40 k:50 </div>
        </div>

        <div className="Color">
          <div className="Color-red"></div>
          <div> #ec1f24 </div>
          <div> c:0 m:100 y:100 k:0 </div>
        </div>

        <div className="Color">
          <div className="Color-blue"></div>
          <div> #27539c </div>
          <div> c:100 m:70 y:0 k:10 </div>
        </div>

        <h4> Refrigerantes </h4>

        <div className="Color">
          <div className="Color-darkblue"></div>
          <div> #273c4d </div>
          <div> c:80 m:60 y:40 k:50 </div>
        </div>

        <div className="Color">
          <div className="Color-red"></div>
          <div> #ec1f24 </div>
          <div> c:0 m:100 y:100 k:0 </div>
        </div>

        <div className="Color Hide">
          <div className="Color-red"></div>
        </div>

        <h4> Combustíveis </h4>

        <div className="Color">
          <div className="Color-darkblue"></div>
          <div> #273c4d </div>
          <div> c:80 m:60 y:40 k:50 </div>
        </div>

        <div className="Color">
          <div className="Color-red"></div>
          <div> #ec1f24 </div>
          <div> c:0 m:100 y:100 k:0 </div>
        </div>

        <div className="Color">
          <div className="Color-orange"></div>
          <div> #f48320 </div>
          <div> c:0 m:60 y:100 k:0 </div>
        </div>

        <h4> Incorporações </h4>

        <div className="Color">
          <div className="Color-darkblue"></div>
          <div> #273c4d </div>
          <div> c:80 m:60 y:40 k:50 </div>
        </div>

        <div className="Color">
          <div className="Color-red"></div>
          <div> #ec1f24 </div>
          <div> c:0 m:100 y:100 k:0 </div>
        </div>

        <div className="Color">
          <div className="Color-purple"></div>
          <div> #4f1b66 </div>
          <div> c:76 m:100 y:14 k:28 </div>
        </div>

      </div>
    </div>
  </Element>

  <Element name="textura" className="Block Center">

    <h1 className="red-txt Mob-Title"> Texturas preferenciais </h1>

    <div className="Text-Wrapper Text-Left second">

      <h1 className="red-txt Hide-Mobile"> Texturas preferenciais </h1>

      <p> As texturas são partes importantes na construção das peças e aqui estão colocadas como referências para
      produção fotográfica e ideográfica de layouts e criações alltype. Estes mateiras estão presentes neste guia em
      caráter de referência. Afinal, é impossível que todo couro seja igual ou que as folhas de grama sejam padronizadas. </p>

    </div>

    <CustomPhotoSwipe items={[{
        src: require('../img/EVisual/texturas.jpg'),
        w: 1000,
        h: 400,
        title: 'Texturas'
      }]}>
      <div className="Img-Wrapper first Fill">
        <img src={require("../img/EVisual/texturas.jpg")}/>
        <div className="lupa"> <img src={require("../img/lupa.svg")}/> </div>
      </div>
    </CustomPhotoSwipe>

  </Element>

  <Element name="banco-de-icones" className="Block Over-Block Center">

    <h1 className="red-txt Mob-Title"> Banco de ícones </h1>

      <div className="bg-Overlap left Hide-Mobile">
        <img src={require("../img/EVisual/icones.jpg")}/>
      </div>

      <CustomPhotoSwipe className="Hide-Desktop" items={[{
          src: require('../img/EVisual/icones.jpg'),
          w: 1280,
          h: 720,
          title: 'Icones'
        }]}>
        <div className="Img-Wrapper first Hide-Desktop Ico-Ajust">
          <img src={require("../img/EVisual/icones.jpg")}/>
          <div className="lupa"> <img src={require("../img/lupa.svg")}/> </div>
        </div>
      </CustomPhotoSwipe>


      <div className="Overlap">
        <div className="Text-Wrapper">

          <h1 className="red-txt"> Banco de ícones </h1>

          <p> Os ícones são importantes para deixar o material mais didático. Existe um padrão de
          desenho que deve ser levado em conta. O banco de ícones está disponível para uso e, caso seja necessária a criação de outros, atente-se para o
          estilo de ilustração utilizado. </p>

          <ol>
            <li> <p> Simplicidade: sempre feitos em traços simples e de entendimento direto. </p> </li>
            <li> <p> Cores de Paleta: não devem ser multicoloridas e com efeitos de acabamento. As cores da paleta sempre devem prevalecer. </p> </li>
            <li> <p> Estilo: é sempre icônico, não sendo indicado o uso de cartoons ou personagens infantilizados. </p> </li>
          </ol>

        </div>
    </div>
  </Element>

  <Element name="tipografia" className="Block Player-Block">

    <h1 className="red-txt Mob-Title"> Tipografia </h1>

    <div className="Text-Wrapper second">
      <h1 className="red-txt Hide-Mobile"> Tipografia </h1>

      <p> A comunicação da Brasal passa a adotar a Rubik como tipo oficial.
      Ela e suas variações são de uso permitido. </p>
    </div>

    <CustomPhotoSwipe items={[{
        src: require('../img/EVisual/tipografia.jpg'),
        w: 2080,
        h: 720,
        title: 'tipografia'
      }]}>
      <div className="Img-Wrapper first">
        <img src={require("../img/EVisual/tipografia.jpg")}/>
        <div className="lupa"> <img src={require("../img/lupa.svg")}/> </div>
      </div>
    </CustomPhotoSwipe>

  </Element>

</div>

);



// WEBPACK FOOTER //
// ./src/pages/ExpressaoVisual.js